import React from 'react';
import './styles/DesignerStyles.css';

import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

class CupIconSvgComponent extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;
  }

  getColor = () => {
    let winningTeamName = this.props.teamName;

    let color = winningTeamName.split(' ')[0].toLowerCase();

    switch (color) {
      case 'blue':
        color = '#078BEB';
        break;
      case 'green':
        color = '#4FCE8B';
        break;
      case 'yellow':
        color = '#EBAA07';
        break;
      case 'orange':
        color = '#E07C43';
        break;
      case 'red':
        color = '#DA4040';
        break;
      case 'brown':
        color = '#8E6C3A';
        break;
      case 'purple':
        color = '#705FCC';
        break;
      case 'pink':
        color = '#B05FCC';
        break;
      case 'white':
        color = '#FFFFFF';
        break;
      case 'gray':
        color = '#727272';
        break;

      default:
        color = '#078BEB';
        break;
    }

    return color;
  };

  render() {
    return (
      <div style={{ zIndex: 1, width: '200px', height: '200px' }}>
        <svg
          width="206"
          height="206"
          viewBox="0 0 206 206"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_561_795)">
            <circle
              id="circleOutline"
              cx="103"
              cy="103"
              r="81"
              stroke={this.getColor()}
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="bevel"
              strokeDasharray="72 76 12 30"
            />
            <rect
              id="rectOutline"
              x="41"
              y="41"
              width="124"
              height="124"
              rx="62"
              fill="#474F71"
              stroke={this.getColor()}
              strokeWidth="4"
            />
            <g clipPath="url(#clip0_561_795)">
              <path
                d="M109.8 145.375V142.5H96.1967V145.375H109.8Z"
                fill="url(#paint0_linear_561_795)"
              />
              <path
                d="M115.371 152V147.66H90.6318V152H115.371Z"
                fill="url(#paint1_linear_561_795)"
              />
              <path
                d="M93.2275 127.657H96.5738V61.13L87.1782 68.674L93.2275 127.657Z"
                fill="url(#paint2_linear_561_795)"
              />
              <path
                d="M109.426 61.13V127.657H112.773L118.822 68.674L109.426 61.13Z"
                fill="url(#paint3_linear_561_795)"
              />
              <path
                d="M103 54L101.544 55.0941V134.594H104.456V55.0941L103 54Z"
                fill="url(#paint4_linear_561_795)"
              />
              <path
                d="M86.8258 113.66L82.6827 76.4175L72 86.5185L84.172 113.66H86.8258Z"
                fill="url(#paint5_linear_561_795)"
              />
              <path
                d="M121.828 113.66L134 86.5185L123.317 76.4175L119.174 113.66H121.828Z"
                fill="url(#paint6_linear_561_795)"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_d_561_795"
              x="0"
              y="0"
              width="206"
              height="206"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="10" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_561_795"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_561_795"
                result="shape"
              />
            </filter>
            <linearGradient
              id="paint0_linear_561_795"
              x1="109.8"
              y1="143.938"
              x2="96.1967"
              y2="143.938"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#EBAB07" />
              <stop offset="1" stopColor="#D27662" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_561_795"
              x1="115.371"
              y1="149.83"
              x2="90.6318"
              y2="149.83"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#EBAB07" />
              <stop offset="1" stopColor="#D27662" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_561_795"
              x1="91.876"
              y1="61.13"
              x2="91.876"
              y2="127.657"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#EBAB07" />
              <stop offset="1" stopColor="#D27662" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_561_795"
              x1="114.124"
              y1="61.13"
              x2="114.124"
              y2="127.657"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#EBAB07" />
              <stop offset="1" stopColor="#D27662" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_561_795"
              x1="103"
              y1="54"
              x2="103"
              y2="134.594"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#EBAB07" />
              <stop offset="1" stopColor="#D27662" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_561_795"
              x1="79.4129"
              y1="76.4175"
              x2="79.4129"
              y2="113.66"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#EBAB07" />
              <stop offset="1" stopColor="#D27662" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_561_795"
              x1="126.587"
              y1="76.4175"
              x2="126.587"
              y2="113.66"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#EBAB07" />
              <stop offset="1" stopColor="#D27662" />
            </linearGradient>
            <clipPath id="clip0_561_795">
              <rect
                width="62"
                height="98"
                fill="white"
                transform="translate(72 54)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    );
  }
}

export default withCookies(CupIconSvgComponent);
